import React, { useContext, useState,useEffect,useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MenuContext } from "../MenuContext";
import "../App.css";
import bestBudgetIcon from "../Assets/bestBudgetIcon.webp";
import toggleButton from "../Assets/LandingWebsite/toggleButton.svg";
import toggleCloseButton from "../Assets/LandingWebsite/toggleCloseButton.svg";
import currentPageIndicator from "../Assets/currentPageIndicator.svg";
import qrSmall from '../Assets/qr.svg';
import qrLarge from "../Assets/qr-code.svg";

const Header = () => {
  const { isMenuOpen, toggleMenu } = useContext(MenuContext);
  const navigate = useNavigate();
  const [qrOpen, setQrOpen] = useState(false);
 // for hover display
 const modalRef = useRef(null);

 useEffect(() => {
  function handleClickOutside(event) {
    if (qrOpen && modalRef.current && !modalRef.current.contains(event.target)) {
      setQrOpen(false);  // close reliably
    }
  }
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [qrOpen]);

  const toggleNavbarMenu = () => {
    toggleMenu(!isMenuOpen);
  };

  const pages = [
    { path: "/why-best-budget", label: "Why Best Budget", imgAlt: "Why Choose Best Budget: Overview of Features" },
    { path: "/pricing", label: "Pricing", imgAlt: "Best Budget Pricing Plans" },
    { path: "/learn", label: "Learn", imgAlt: "Learn More About Best Budget Features" },
    { path: "/about-us", label: "About Us", imgAlt: "About Best Budget" },
    { path: "/blog", label: "Blog", imgAlt: "Best Budget Blog" },
  ];

  return (
    <div className="head">
      <div className="header-container">
        <div className={window.location.pathname === "/blog" ? "no-borders navbar" : " navbar"}>
          <nav className="navbar-container" aria-label="Main navigation">
            <div className="title-logo">
              <img alt="best-budget" src={bestBudgetIcon}   style={{'cursor':'pointer'}}  onClick={() => navigate("/")} />
             
            </div>

            {pages.map((page, index) => (
              <div
                key={page.path}
                className={`page page${index + 1} ${window.location.pathname === page.path ? "active-page" : ""}`}
              >
                <Link to={page.path} className="nav-link">{page.label}</Link>
                <img
                  alt={page.imgAlt}
                  src={currentPageIndicator}
                  className={window.location.pathname === page.path ? "active-page-indicator" : "img"}
                />
              </div>
            ))}

            {/* Small QR icon in header with hover */}
            <div
              className="qr-wrapper"
              onClick={() => setQrOpen(true)}
           
            >
              <img src={qrSmall} alt="QR Code" className="qr-small" />

           
            </div>
          </nav>

          <div className="navbar-mobile-container">
            <div className="best-budget-div">
              <div
                className="navbar-brand"
                onClick={() => {
                  navigate("/");
                  if (isMenuOpen) toggleNavbarMenu();
                }}
              ></div>
            </div>
            <div className="toggle-button-div" onClick={toggleNavbarMenu}>
              {!isMenuOpen ? (
                <img alt="toggle-btn" src={toggleButton} />
              ) : (
                <img alt="toggle-close" src={toggleCloseButton} />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-nav">
        {isMenuOpen && (
          <div className="mobile-nav-menu-div">
            {pages.map((page) => (
              <h1
                key={page.path}
                className="nav-item"
                onClick={() => {
                  navigate(page.path);
                  toggleMenu();
                }}
              >
                {page.label}
              </h1>
            ))}
          </div>
        )}
      </div>

      {/* QR modal */}
    {/* QR modal */}
{/* QR modal */}
{qrOpen && (
  <div className="qr-overlay">
    <div
      ref={modalRef}
      className="qr-modal"
      onClick={() => setQrOpen(false)}
    >
     
      <img src={qrLarge} alt="QR Code" className="qr-large" />
      <p className="qr-text">Scan this QR code to install the mobile app now</p>
    </div>
  </div>
)}

    </div>
  );
};

export default Header;
